import { render } from "./base-template.vue?vue&type=template&id=3788703b"
import script from "./base-template.vue?vue&type=script&lang=js"
export * from "./base-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__